import { TuiIconTdsIllustrationsCommonErrorRedLight } from '@tui-react/proprietary-icons';
import React from 'react';
import intl from '../../locale';
import { NewOverlay } from '../NewOverlay';
import styles from './NewForbiddenErrorOverlay.module.css';

export const NewForbiddenErrorOverlay: React.FC<{
  isWebview: boolean;
  onClose: VoidFunction;
}> = ({ isWebview, onClose }) => {
  const description = (
    <span className={styles.info}>{intl.formatMessage({ id: 'System.NewForbiddenErrorDescription' })}</span>
  );

  return (
    <NewOverlay
      onClose={onClose}
      isWebview={isWebview}
      description={description}
      icon={<TuiIconTdsIllustrationsCommonErrorRedLight iconSize={160} />}
      title={intl.formatMessage({ id: 'System.NewForbiddenErrorTitle' })}
    />
  );
};
